import { render } from "./PublicExamsList.vue?vue&type=template&id=8b97e64a&ts=true"
import script from "./PublicExamsList.vue?vue&type=script&lang=ts"
export * from "./PublicExamsList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__